// export const RANK_TIERS = [
//     { name: "Novice Oracle", maxPoints: 100 },
//     { name: "Apprentice Seer", maxPoints: 500 },
//     { name: "Adept Prophet", maxPoints: 1000 },
//     { name: "Prediction Sage", maxPoints: 2500 },
//     { name: "Master Oracle", maxPoints: 5000 },
//     { name: "Grand Seer", maxPoints: Infinity }, // Last rank has no max
//   ];
  
export const RANK_TIERS = [
  { name: "Rookie", maxPoints: 100 },
  { name: "Scout", maxPoints: 300 },
  { name: "Player", maxPoints: 700 },
  { name: "Captain", maxPoints: 1500 },
  { name: "Hotshot", maxPoints: 2500 },
  { name: "Assistant OC", maxPoints: 4000 },
  { name: "Clutch", maxPoints: 6000 },
  { name: "Starter", maxPoints: 8000 },
  { name: "Sharp", maxPoints: 12000 },
  { name: "Boss", maxPoints: 17000 },
  { name: "Risker", maxPoints: 23000 },
  { name: "Betman", maxPoints: 30000 },
  { name: "Sniper", maxPoints: 40000 },
  { name: "Parlay", maxPoints: 50000 },
  { name: "Prop", maxPoints: 65000 },
  { name: "Wager", maxPoints: 80000 },
  { name: "Hustler", maxPoints: 100000 },
  { name: "Sage", maxPoints: 125000 },
  { name: "Streaker", maxPoints: 150000 },
  { name: "Odds Man", maxPoints: 200000 },
  { name: "Legend", maxPoints: 300000 },
  { name: "Bucketz", maxPoints: 500000 },
  { name: "Champ", maxPoints: 750000 },
  { name: "God Mode", maxPoints: 1000000 },
  { name: "GOAT", maxPoints: Infinity }, // The top tier
];
